import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tlc-churn-flow-tellent-logo',
  templateUrl: './churn-flow-tellent-logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ChurnFlowTellentLogoComponent {}
